<template>
  <div v-if="followedSearch" class="modal fade" :id="'deleteFollowedSearch-' + followedSearch.id" tabindex="-1" role="dialog"  aria-hidden="true">
    <div v-if="show !== false" class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Delete monitored search</h4>
        </div>
        <div class="modal-body">
          <h3>Are you sure you want to delete this monitored search : {{followedSearch.search_terms.term}}?</h3>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
          <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="deleteFollowedSearch">Delete</vue-ladda>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  name: 'DeleteFollowedSearch',
  components: {
    VueLadda
  },
  data () {
    return {
      show: false,
      followedSearch: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
    },
    openModal: function () {
      this.show = true

      setTimeout(() => {
        $('#deleteFollowedSearch-' + this.followedSearch.id).modal('show')
      }, 200)

      $('#deleteFollowedSearch-' + this.followedSearch.id).on('hide.bs.modal', () => {
        this.show = false
      })
    },
    setFollowedSearch: function (followedSearch) {
      this.followedSearch = followedSearch
    },
    deleteFollowedSearch: function () {
      this.axios.delete('follow/search/' + this.followedSearch.id).then(() => {
        this.$notify({
          type: 'success',
          title: '',
          content: 'Search followed updated',
          placement: 'bottom-right'
        })

        $('#deleteFollowedSearch-' + this.followedSearch.id).modal('hide')
        this.$emit('updateFollowedSearch')
      }).catch((error) => {
      }).finally(() => {
        this.submit.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/DeleteFollowedSearch.vue